import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_OLD, offerIncludes, offerRows } from '../data/finanza';
import { REAL_MOCKUP as PRODUCT_IMAGE } from '../data/realImages';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-[#1E2B58] px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-234" data-mp="1hofmtprn534w">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-235" data-mp="tyv1x1bxfvsz">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-236" data-mp="u0obaodxcu4o">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-237" data-mp="p1200khnpnyi">
            Scopri il tuo pacchetto completo <em className="text-[#F2B134]" data-id="element-238" data-mp="13uy5mbmfg2i1">FINANZA PRONTA™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-239" data-mp="yx4xve5h70fn">
            Il tuo anno di educazione finanziaria – 100% già pronto. Entra in aula con l'educazione finanziaria già pronta.
          </p>
          {PRODUCT_IMAGE && <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-240" data-mp="2affss69j8gz7" />}
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-[#1E2B58] shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-241" data-mp="uiiprwfvsvro">
          {PRODUCT_IMAGE && <img src={PRODUCT_IMAGE} alt="FINANZA PRONTA™: 6 volumi + 5 bonus" className="mx-auto mb-6 w-full max-w-[16rem] drop-shadow-xl lg:hidden" data-id="element-242" data-mp="zgka0kp1n14q" />}
          <p className="text-sm font-semibold text-[#1E2B58]/60" data-id="element-243" data-mp="6usj63gxoiav">Il pacchetto completo contiene</p>

          <ul className="mt-5 divide-y divide-[#1E2B58]/10 border-y border-[#1E2B58]/10" data-id="element-244" data-mp="btlupqcntz8e">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-245" data-mp="fsup8xfiy150">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#1F9D6B]" data-id="element-246" data-mp="klnox6w4yja8">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-247" data-mp="3k7kmefslmyg3" />
                </span>
                <span data-id="element-248" data-mp="3o8o12yywuofq">
                  <span className="block font-medium leading-snug" data-id="element-249" data-mp="3o7uvi1bou4z6">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-[#1E2B58]/65" data-id="element-250" data-mp="vdnwwp85g39r">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-251" data-mp="154iirshhh0uo">
            <p className="text-sm font-medium text-[#1E2B58]/70 sm:pb-2" data-id="element-252" data-mp="108jz2i73o70l">
              Prezzo di lancio <span className="ml-1 text-[#1E2B58]/50" data-id="element-253" data-mp="ciz5z6h8ftdl">invece di <s data-id="element-254" data-mp="7il82h9chzta">{PRICE_OLD}</s></span>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-[#1E2B58] sm:text-8xl" data-id="element-255" data-mp="7jw7y5zo6nf4">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-[#1E2B58]/70 sm:justify-end" data-id="element-256" data-mp="hewkr8cukro9">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="1wvf0b6ehntoa" />
            Pagamento unico. Nessun abbonamento.
          </p>

          <CtaButton label="Voglio il pacchetto completo" className="mt-8 w-full" data-id="element-258" data-mp="1sxh77shlknfm" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-[#1E2B58]/60" data-id="element-259" data-mp="20dce8dhfwcx8">
            {offerIncludes.map(item => <li key={item} data-id="element-260" data-mp="1qgpu5qwxtpw9">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}